import { createFileRoute, Outlet } from "@tanstack/react-router";
import { RouteGuard } from "@/components/auth/RouteGuard";

export const Route = createFileRoute("/_authenticated/insurance")({
  component: () => (
    <RouteGuard module="insurance"><Outlet /></RouteGuard>
  ),
});
